<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.4 14.55">
   <path d="M7.18 3.57c3.29-.009 4.946 3.966 2.623 6.296C7.48 12.195 3.5 10.55 3.5 7.26a3.69 3.69 0 013.68-3.69z"
      class="inner" fill="#2c3d50" />
   <path
      d="M7.207 14.392c-6.335 0-9.506-7.658-5.027-12.137C6.659-2.225 14.317.947 14.317 7.282a7.11 7.11 0 01-7.11 7.11zm0-12.72c-4.998 0-7.5 6.043-3.967 9.577 3.534 3.534 9.577 1.031 9.577-3.967a5.61 5.61 0 00-5.61-5.61z"
      class="outer" fill="#2c3d50" />
</svg>